export default [
    {
        _name: 'CSidebarNav',
        _children: [
            {
                _name: 'CSidebarNavItem',
                name: 'Home',
                lookupName: 'Home',
                to: '/home',
                icon: 'cil-home'
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Markets',
                lookupName: 'Markets',
                to: '/Markets',
                icon: 'cil-chart-line'
            },
            {
                _name: 'CSidebarNavDropdown',
                name: 'Alerts',
                lookupName: 'Alerts',
                route: '/alerts',
                icon: 'cil-bell',
                items: [
                    {
                        name: 'TriggerHitAlert',
                        lookupName: 'Hit Triggers',
                        to: '/alerts/triggerHitAlert',
                    },
                    {
                        name: 'StatusAlert',
                        lookupName: 'Trigger Status',
                        to: '/alerts/statusAlert',
                    },
                    {
                        name: 'DeadlineAlert',
                        lookupName: 'Default Deadlines',
                        to: '/alerts/deadlineAlert',
                    }]
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Clients',
                lookupName: 'Clients',
                to: '/clients',
                icon: 'cil-people'
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Companies',
                lookupName: 'Companies',
                to: '/companies',
                icon: 'cil-industry'
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Contracts',
                lookupName: 'Contracts',
                to: '/contracts',
                icon: 'cil-file'
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Trading Groups',
                lookupName: 'Trading Groups',
                to: '/tradingGroups',
                icon: 'cil-object-group'
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Trades',
                lookupName: 'Trades',
                to: '/trades',
                icon: 'cil-check'
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Uploads',
                lookupName: 'Uploads',
                to: '/uploads',
                icon: 'cil-cloud-upload'
            },
            {
                _name: 'CSidebarNavDropdown',
                name: 'Reports',
                lookupName: 'Reports',
                to: '/reports',
                icon: 'cil-bar-chart',
                items: [
                    {
                        name: 'Report Templates',
                        lookupName: 'Report Templates',
                        to: '/reports/reports',
                    },
                    {
                        name: 'AvailableReports',
                        lookupName: 'Available Reports',
                        to: '/reports/availableReports',
                    },
                    {
                        name: 'AdminReports',
                        lookupName: 'Management Reports',
                        to: '/reports/adminReports',
                    }
                ]
            },
            {
                _name: 'CSidebarNavDropdown',
                name: 'Triggers',
                lookupName: 'Triggers',
                to: '/Triggers',
                icon: 'cil-warning',
                items: [{
                    name: 'LiveTrigger',
                    lookupName: 'Live',
                    to: '/triggers/Live',

                },
                {
                    name: 'DueLiveTrigger',
                    lookupName: 'Due Live',
                    to: '/triggers/DueLive',

                },
                {
                    name: 'ExpiredTrigger',
                    lookupName: 'Expired',
                    to: '/triggers/Expired',

                }]
            },
  
            {
                _name: 'CSidebarNavItem',
                name: 'Management',
                lookupName: 'Management',
                to: '/Management',
                icon: 'cil-chart-pie'
            },
            {
                _name: 'CSidebarNavDropdown',
                name: 'Administration',
                lookupName: 'Administration',
                route: '/administration',
                icon: 'cil-settings',
                items: [
                    {
                        name: 'Users & Permissions',
                        lookupName: 'Users & Permissions',
                        to: '/administration/users'
                    },
                    {
                        name: 'Product Specifications',
                        lookupName: 'Product Specifications',
                        to: '/administration/products'
                    },
                    {
                        name: 'General',
                        lookupName: 'General',
                        to: '/administration/general'
                    },
                    {
                        name: 'Contract Management',
                        lookupName: 'Contract Management',
                        to: '/administration/contractManagement'
                    },
                    {
                        name: 'Units',
                        lookupName: 'Units',
                        to: '/administration/Units'
                    },
             
                ]
            },
            {
                _name: 'CSidebarNavItem',
                name: 'SecureVersion',
                lookupName: 'Secure version',
                to: '/secureVersion',
                icon: 'cil-folder'
            }
        ]
    }
]